import { fromEmpty } from 'maybeasy';
import { observer } from 'mobx-react';
import * as React from 'react';
import { emptyFragment } from '../../../../../../EmptyFragment';
import LearningCollectionEditStore from '../../../Edit/Store';
import { ModifiableExperiencesContext } from '../../../Types';
import DraggableRow from './DraggableRow';
import EmptyExperiences from './EmptyExperiences';

interface Props {
  context: ModifiableExperiencesContext;
  learningCollectionStore: LearningCollectionEditStore;
}

const Experiences: React.FC<Props> = ({ context, learningCollectionStore }) =>
  fromEmpty(learningCollectionStore.experienceStores(context))
    .map((arr) => (
      <DraggableRow
        context={context}
        learningCollectionStore={learningCollectionStore}
        experienceStores={arr}
      />
    ))
    .orElse(() =>
      fromEmpty(learningCollectionStore.deletedExperienceStores(context)).map(emptyFragment),
    )
    .getOrElse(() => {
      return <EmptyExperiences />;
    });

export default observer(Experiences);
